module.exports = __webpack_public_path__ + "packs/media/images/warum_mm_1-d4eaa3c0b77b6df0172a79f52b12b9dd.jpg";